var $9c3b35ecd7c5e348$exports = {};
$9c3b35ecd7c5e348$exports = {
  "help": `Pal\u{12B}dz\u{12B}ba`,
  "info": `Inform\u{101}cija`
};
export { $9c3b35ecd7c5e348$exports as default };